module.exports = __webpack_public_path__ + "static/media/store-android.fadc348d.svg";